import { render } from "./OdontogramTreatmentHistoryModal.vue?vue&type=template&id=0284d45c"
import script from "./OdontogramTreatmentHistoryModal.vue?vue&type=script&lang=js"
export * from "./OdontogramTreatmentHistoryModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__